"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useListItem = useListItem;
var React = _interopRequireWildcard(require("react"));
var _extractEventHandlers = require("../utils/extractEventHandlers");
var _listActions = require("./listActions.types");
var _ListContext = require("./ListContext");
/**
 * Contains the logic for an item of a list-like component (for example Select, Menu, etc.).
 * It handles the item's mouse events and tab index.
 *
 * @template ItemValue The type of the item's value. This should be consistent with the type of useList's `items` parameter.
 * @ignore - internal hook.
 */ function useListItem(parameters) {
    var _parameters_handlePointerOverEvents = parameters.handlePointerOverEvents, handlePointerOverEvents = _parameters_handlePointerOverEvents === void 0 ? false : _parameters_handlePointerOverEvents, item = parameters.item;
    var listContext = React.useContext(_ListContext.ListContext);
    if (!listContext) {
        throw new Error('useListItem must be used within a ListProvider');
    }
    var dispatch = listContext.dispatch, getItemState = listContext.getItemState;
    var _getItemState = getItemState(item), highlighted = _getItemState.highlighted, selected = _getItemState.selected, focusable = _getItemState.focusable;
    var createHandleClick = React.useCallback(function(externalHandlers) {
        return function(event) {
            var _externalHandlers_onClick;
            (_externalHandlers_onClick = externalHandlers.onClick) === null || _externalHandlers_onClick === void 0 ? void 0 : _externalHandlers_onClick.call(externalHandlers, event);
            if (event.defaultPrevented) {
                return;
            }
            if (process.env.NODE_ENV !== 'production') {
                if (item === undefined) {
                    throw new Error([
                        'MUI: The `item` provided to useListItem() is undefined.',
                        'This should happen only during server-side rendering under React 17.'
                    ].join('\n'));
                }
            }
            dispatch({
                type: _listActions.ListActionTypes.itemClick,
                item: item,
                event: event
            });
        };
    }, [
        dispatch,
        item
    ]);
    var createHandlePointerOver = React.useCallback(function(externalHandlers) {
        return function(event) {
            var _externalHandlers_onMouseOver;
            (_externalHandlers_onMouseOver = externalHandlers.onMouseOver) === null || _externalHandlers_onMouseOver === void 0 ? void 0 : _externalHandlers_onMouseOver.call(externalHandlers, event);
            if (event.defaultPrevented) {
                return;
            }
            if (process.env.NODE_ENV !== 'production') {
                if (item === undefined) {
                    throw new Error([
                        'MUI: The `item` provided to useListItem() is undefined.',
                        'This should happen only during server-side rendering under React 17.'
                    ].join('\n'));
                }
            }
            dispatch({
                type: _listActions.ListActionTypes.itemHover,
                item: item,
                event: event
            });
        };
    }, [
        dispatch,
        item
    ]);
    var tabIndex;
    if (focusable) {
        tabIndex = highlighted ? 0 : -1;
    }
    var getRootProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var externalEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(externalProps);
        return _object_spread_props(_object_spread({}, externalProps), {
            onClick: createHandleClick(externalEventHandlers),
            onPointerOver: handlePointerOverEvents ? createHandlePointerOver(externalEventHandlers) : undefined,
            tabIndex: tabIndex
        });
    };
    return {
        getRootProps: getRootProps,
        highlighted: highlighted,
        selected: selected
    };
}
